<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Búsqueda de {{'Movimiento' | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="!isEstadoSearching">Estados</mat-label>
                <mat-label class="text-style" *ngIf="isEstadoSearching">Cargando...</mat-label>
                <mat-select multiple class="text-style" formControlName="Estados" [compareWith]="compareEstados">
                  <mat-option class="text-style" *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="!isRosbaco"  fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select class="text-style" formControlName="MonedaId">
                  <mat-option class="text-style">Todos</mat-option>
                  <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style">Categoria</mat-label>
                <mat-select class="text-style" formControlName="Signo">
                  <mat-option class="text-style">Todos</mat-option>
                  <mat-option class="text-style" *ngFor="let s of categoriaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="!isTipoSearching">Tipo de Movimiento</mat-label>
                <mat-label class="text-style" *ngIf="isTipoSearching">Cargando...</mat-label>
                <mat-select class="text-style" formControlName="TipoMovimientoId">
                  <mat-option class="text-style">Todos</mat-option>
                  <mat-option class="text-style" *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div *ngIf="!isRosbaco"  fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="!isMedioPagoSearching">Medio de Pago</mat-label>
                <mat-label class="text-style" *ngIf="isMedioPagoSearching">Cargando...</mat-label>
                <mat-select class="text-style" formControlName="MedioPagoId">
                  <mat-option class="text-style">Todos</mat-option>
                  <mat-option class="text-style" *ngFor="let s of medioPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="!isRosbaco"  fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label class="text-style">Fecha Vencimiento Desde</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngIf="!isRosbaco"  fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style">Fecha Vencimiento Hasta</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div *ngIf="!isRosbaco" fxFlex=66 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Detalle</mat-label>
                <input matInput formControlName="Detalle" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos || tenantFeatureFlags?.HabilitarControlContratos">

              <hr  *ngIf="!isRosbaco" width="100%" style="margin: 5px 0px;">
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos && !isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Pedido</mat-label>
                  <input matInput formControlName="PedidoId" type="number" (keyup.enter)="onSearch()">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlContratos  && !isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Cód. Contrato</mat-label>
                  <input matInput formControlName="Contrato" (keyup.enter)="onSearch()">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>

            </ng-container>

            <hr width="100%" style="margin: 5px 0px;">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                <mat-select formControlName="ConsorcioId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                <mat-select formControlName="UnidadFuncionalId">
                  <mat-option>Ninguna</mat-option>
                  <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                  [matAutocomplete]="proveedor" formControlName="Proveedor">
                <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                  class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                  {{s.RazonSocial }}
                </mat-option>
              </mat-autocomplete>

            </div>
            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Usuario</mat-label>
                <input matInput formControlName="Usuario" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Documento</mat-label>
                <input matInput formControlName="NroDocumento" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Email</mat-label>
                <input matInput formControlName="MailContacto" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div *ngIf="!isRosbaco" fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Celular</mat-label>
                <input matInput formControlName="MovilContacto" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-checkbox formControlName="VerSoloDeudasPendientes" (keyup.enter)="onSearch()" color="primary">Ver solo deudas pendientes</mat-checkbox>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-checkbox formControlName="VerSoloActivos" (keyup.enter)="onSearch()" color="primary">Ver solo activos</mat-checkbox>
            </div>

          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

        <div fxFlex=80 fxFlex.xs=100 class="flex-item">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="add()" *ngIf="canAdd" [disabled]="isProcessing()" color="primary" class="zb-button">Agregar</button>
            <button mat-raised-button (click)="onSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
            <button mat-raised-button (click)="onExport()" [disabled]="isProcessing()" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
            <button mat-raised-button (click)="financiar()" *ngIf="canFinanciar" [disabled]="isProcessing()" class="zb-button">Financiar {{'MovimientoDeuda' | translate}}</button>
            <button mat-raised-button (click)="pagosMasivos()" *ngIf="canAddPago && !isRosbaco" [disabled]="isProcessing()" color="primary" class="zb-button">{{'MovimientoPago' | translate}} Masivo</button>
            <button mat-raised-button (click)="cancelacionMasiva()" *ngIf="canCancelar" [disabled]="isProcessing()" color="warn" class="zb-button">
              {{isCancelling ? 'Cancelando...' : 'Cancelación Masiva'}}
            </button>
            <button mat-raised-button (click)="goToMovimientosRecurrentes()" *ngIf="canAddDeuda && canRecurrentes" [disabled]="isProcessing()" class="zb-button">Mov. Recurrentes</button>
            <button mat-raised-button (click)="goToMovimientosDesdeDocumentos()" *ngIf="canAdd && canAnalizarDocs" [disabled]="isProcessing()" color="primary" class="zb-button">Analizar Docs.</button>
          </div>
        </div>

        <div fxFlex=20 fxFlex.xs=100 class="flex-item">
          <div fxLayout="row-reverse stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="multiSelectionEnabled = !multiSelectionEnabled" [disabled]="isProcessing()" class="zb-button">
              {{multiSelectionEnabled ? 'Cancelar Selección' : 'Selección Múltiple'}}
            </button>
          </div>
        </div>

      </div>

      <br/>

      <mat-expansion-panel [expanded]="false" [hideToggle]="false" class="zb-readonly" *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fa fa-solid fa-chart-area fa-1x" style="margin-right: 5px;"></i> Estadísticas de la Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTALES:</b></mat-label>
              <br/>
              <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              <ng-container *ngIf="!isStatisticsSearching">
                <mat-label *ngFor="let item of totales | keyvalue" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTALES SALDO:</b></mat-label>
              <br/>
              <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              <ng-container *ngIf="!isStatisticsSearching">
                <mat-label *ngFor="let item of totalesSaldos | keyvalue" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

          <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="totalesSeleccionados != null && totalesSeleccionados.length > 0">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTAL SELECCIONADO:</b></mat-label>
              <br/>
              <ng-container *ngIf="!isSearching">
                <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">

        <ng-container *ngIf="!multiSelectionEnabled">

          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
            [pageSettings]='pageSettings' [allowResizing]='true' (actionBegin)="onActionBegin($event)" [contextMenuItems]='contextMenuItems' (contextMenuClick)='contextMenuClick($event)' (contextMenuOpen)='contextMenuOpen($event)'>
            <e-columns>
              <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date' format="dd/MM/yyyy HH:mm:ss"></e-column>
              <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date' format="dd/MM/yyyy"></e-column>
              <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
              <e-column field='CuentaImputadaCodigo' headerText='Cuenta' width=90></e-column>
              <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
              <e-column field='Detalle' headerText='Detalle' width=100></e-column>
              <e-column field='Estado' headerText='Estado' width=80>
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: getEstadoBackgroundColor(data) }">{{data.Estado}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='AlicuotaIvaNombre' headerText='IVA' width=50></e-column>
              <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=80 textAlign='Center'>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                  <a style="cursor: pointer;" (click)="onReject(data)" *ngIf="data.PuedeRechazar" title="Cancelar movimiento">
                    <i class="fa fa-times fa-1x"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>

        </ng-container>


        <ng-container *ngIf="multiSelectionEnabled">

          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (actionBegin)="onActionBegin($event)"
            (rowSelected)='onRowSelect($event)' (rowDeselected)="onRowDeselected($event)" (rowSelecting)="rowSelecting($event)"
            (mousedown)="onClickRow($event)"
            (contextMenuClick)='contextMenuClick($event)' [contextMenuItems]='contextMenuItems' (contextMenuOpen)='contextMenuOpen($event)'
            >
            <e-columns>
              <e-column type="checkbox" width=70></e-column>
              <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date' format="dd/MM/yyyy HH:mm:ss"></e-column>
              <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date' format="dd/MM/yyyy"></e-column>
              <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
              <e-column field='CuentaImputadaCodigo' headerText='Cuenta' width=90></e-column>
              <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
              <e-column field='Detalle' headerText='Detalle' width=100></e-column>
              <e-column field='Estado' headerText='Estado' width=80>
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: getEstadoBackgroundColor(data) }">{{data.Estado}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='AlicuotaIvaNombre' headerText='IVA' width=50></e-column>
              <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=80 textAlign='Center'>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onReject(data)" *ngIf="data.PuedeRechazar" title="Cancelar movimiento">
                    <i class="fa fa-times fa-1x"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>

        </ng-container>

      </div>

    </ng-container>

  </mat-card-content>
</mat-card>
